import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pin",
  "use": "icon-pin-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 21\" id=\"icon-pin\"><path d=\"M10 1.335c3.314 0 6 2.68 6 5.986a5.974 5.974 0 0 1-.858 3.084L10 18.935l-5.142-8.53a5.978 5.978 0 0 1 2.05-8.214A6.01 6.01 0 0 1 10 1.335Zm0 4.4c-1.171 0-2.121.985-2.121 2.2 0 1.215.95 2.2 2.122 2.2 1.171 0 2.121-.985 2.121-2.2 0-1.215-.95-2.2-2.121-2.2Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol